import styled from 'styled-components';

export const SurveyInputContainer = styled.div<{ gridColumns: number }>`
  width: 100%;

  display: grid;
  grid-template-columns: ${(props) => props.gridColumns && `repeat(${props.gridColumns}, 1fr)`};
  gap: 8px;

  overflow-y: scroll;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;
